
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/track/searchkeyword",
      function () {
        return require("private-next-pages/track/searchkeyword/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/track/searchkeyword"])
      });
    }
  